// // import React from "react";
// // import ReactDOM from "react-dom/client";
// // import App from "./App";
// // import reportWebVitals from "./reportWebVitals";
// // import { BrowserRouter } from "react-router-dom";
// // import { Provider } from "react-redux";
// // import { configureStore } from "@reduxjs/toolkit";
// // import rootReducer from "./slices";
// // import { UserManager } from "oidc-client-ts";
// // import { oidcConfig } from "./config/oidcConfig";
// // export const userManager = new UserManager(oidcConfig);

// // const store = configureStore({ reducer: rootReducer, devTools: true });
// // const root = ReactDOM.createRoot(document.getElementById("root"));

// // root.render(
// //   <Provider store={store}>
// //     <React.Fragment>
// //       <BrowserRouter basename={process.env.PUBLIC_URL}>
// //         <App />
// //       </BrowserRouter>
// //     </React.Fragment>
// //   </Provider>
// // );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// // reportWebVitals();

// import React from "react";
// import ReactDOM from "react-dom/client";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { BrowserRouter } from "react-router-dom";
// import { Provider } from "react-redux";
// import { configureStore } from "@reduxjs/toolkit";
// import rootReducer from "./slices";

// // Tambahan untuk redux-persist
// import {
//   persistStore,
//   FLUSH,
//   REHYDRATE,
//   PAUSE,
//   PERSIST,
//   PURGE,
//   REGISTER,
// } from "redux-persist";
// import { PersistGate } from "redux-persist/integration/react";

// // OIDC
// import { UserManager } from "oidc-client-ts";
// import { oidcConfig } from "./config/oidcConfig";
// export const userManager = new UserManager(oidcConfig);

// // Konfigurasi store dengan middleware yang cocok untuk persist
// const store = configureStore({
//   reducer: rootReducer,
//   devTools: true,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: {
//         ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
//       },
//     }),
// });

// const persistor = persistStore(store);

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <Provider store={store}>
//     <PersistGate loading={null} persistor={persistor}>
//       <BrowserRouter basename={process.env.PUBLIC_URL}>
//         <App />
//       </BrowserRouter>
//     </PersistGate>
//   </Provider>
// );

import './helpers/fetchInterceptor';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// Redux Persist
import { PersistGate } from 'redux-persist/integration/react';

// Store TUNGGAL (lihat store.js) — sebelumnya index.js membuat store +
// persistor kedua yang berbagi key `persist:root` dengan store yang dibaca
// interceptor, menyebabkan state login/persist tidak konsisten.
import store, { persistor } from './store';

// Root render
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter
        basename={process.env.PUBLIC_URL}
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

// Report performance metrics (opsional)
reportWebVitals();
